import React from "react";
import { WotdFormData } from "../../../beans/api";
import { IWotdFormDataSet } from "../../store/WotdFormData/actions";
import CheckboxesComponent from "../CheckboxesComponent";
import { Wrap } from "./styles";

type Props = {
  checkboxes: null | WotdFormData["personalData"];
  handleCheckboxes: (
    wotdCheckboxes: WotdFormData["words"] | WotdFormData["personalData"],
  ) => IWotdFormDataSet;
};

const WotdPrivacy: React.FC<Props> = ({ checkboxes, handleCheckboxes }) => {
  return (
    <Wrap>
      <CheckboxesComponent
        checkboxes={checkboxes}
        handleCheckboxes={handleCheckboxes}
        labels={[
          "newwotd.checkboxes.label.privacy",
          "newwotd.checkboxes.label.copyright",
          "newwotd.checkboxes.label.termofuse",
        ]}
      />
    </Wrap>
  );
};

export default WotdPrivacy;
